import { useI18n } from '@change-corgi/core/react/i18n';

export type PartialComment = {
	createdAtLocalized: string;
	user: {
		displayName: string;
	};
};

type Result = ModelHookResult<{
	a11yLabel: string;
}>;

export function useCommentReportAbuse(comment: PartialComment): Result {
	const { translate } = useI18n();

	return {
		data: {
			a11yLabel: translate('corgi.petition.details.comments.actions.report_a11y', {
				author: comment.user.displayName,
				date: comment.createdAtLocalized,
			}),
		},
	};
}
